var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "msp-budget-deviation" }, [
    _c("div", { staticClass: "msp-budget-deviation__budgets" }, [
      _c(
        "div",
        { staticClass: "msp-budget-deviation__budgets__title" },
        [
          _c("pui-headline", { attrs: { type: "h6" } }, [
            _vm._v(" " + _vm._s(_vm.$t("budgetDeviation")) + " "),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "msp-budget-deviation__chart" },
        [_c("echarts", { attrs: { option: _vm.budgetDeviationOption } })],
        1
      ),
      _c("div", { staticClass: "msp-budget-deviation__footer" }, [
        _vm._v(" " + _vm._s(_vm.$t("plannedMaintenance")) + " "),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }